import { Chart } from 'chart.js'

Chart.defaults.roundedDoughnut = Chart.helpers.clone(Chart.defaults.doughnut)
Chart.controllers.roundedDoughnut = Chart.controllers.doughnut.extend({
  draw: function (ease) {
    const ctx = this.chart.ctx
    const easingDecimal = ease || 1
    const arcs = this.getMeta().data
    Chart.helpers.each(arcs, function (arc, i) {
      // Needed for drawing over other arcs
      ctx.globalCompositeOperation = 'destination-over'

      arc.transition(easingDecimal).draw()

      const pArc = arcs[i === 0 ? arcs.length - 1 : i - 1]
      const pColor = pArc._view.backgroundColor

      const vm = arc._view
      const radius = (vm.outerRadius + vm.innerRadius) / 2
      const thickness = (vm.outerRadius - vm.innerRadius) / 2
      const startAngle = Math.PI - vm.startAngle - Math.PI / 2
      const angle = Math.PI - vm.endAngle - Math.PI / 2

      ctx.save()
      ctx.translate(vm.x, vm.y)

      // Starting circle
      ctx.fillStyle = i === 0 ? vm.backgroundColor : pColor
      ctx.beginPath()
      ctx.arc(radius * Math.sin(startAngle), radius * Math.cos(startAngle), thickness, 0, 2 * Math.PI)
      ctx.fill()

      // Ending circle
      ctx.fillStyle = vm.backgroundColor
      ctx.beginPath()
      ctx.arc(radius * Math.sin(angle), radius * Math.cos(angle), thickness, 0, 2 * Math.PI)
      ctx.fill()

      ctx.restore()
    })
  }
})
